import { render, staticRenderFns } from "./configPage.vue?vue&type=template&id=43d5d7ca&scoped=true"
import script from "./configPage.vue?vue&type=script&lang=js"
export * from "./configPage.vue?vue&type=script&lang=js"
import style0 from "./configPage.vue?vue&type=style&index=0&id=43d5d7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d5d7ca",
  null
  
)

export default component.exports